import axiosClient from "../axiosClient";
import { FlaggedQuestion } from "../types";

export type FlagQuestionResponse = {
  flaggedQuestion: FlaggedQuestion;
  message: string;
};

export async function flagQuestion(
  questionId: number,
  comment: string,
): Promise<FlagQuestionResponse> {
  const response = await axiosClient.post(`/questions/${questionId}/flag`, {
    comment,
  });
  const responseData: FlagQuestionResponse = response.data;
  return responseData;
}
